// extracted by mini-css-extract-plugin
export default {"title":"Comment_title__YP0o6","text":"Comment_text__Uqmig","list":"Comment_list__xfj3O"};